/**
 * Utility per verificare e gestire il cache busting basato sulla versione
 */

import packageInfo from '../../package.json';

export const CURRENT_VERSION = process.env.REACT_APP_VERSION || packageInfo.version;
const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minuti

/**
 * Ottiene la versione dal meta tag nell'index.html
 */
export const getDeployedVersion = () => {
  const meta = document.querySelector('meta[name="app-version"]');
  return meta ? meta.getAttribute('content') : null;
};

/**
 * Controlla se è disponibile una nuova versione
 */
export const checkForNewVersion = async () => {
  try {
    const response = await fetch('/index.html?' + new Date().getTime(), {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const meta = doc.querySelector('meta[name="app-version"]');
    const deployedVersion = meta ? meta.getAttribute('content') : null;
    
    if (deployedVersion && deployedVersion !== CURRENT_VERSION) {
      return {
        hasNewVersion: true,
        currentVersion: CURRENT_VERSION,
        newVersion: deployedVersion
      };
    }
    
    return { hasNewVersion: false };
  } catch (error) {
    console.error('Errore nel controllo versione:', error);
    return { hasNewVersion: false };
  }
};

/**
 * Forza il reload dell'applicazione cancellando la cache
 */
export const forceReload = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  
  // Cancella la cache del browser
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => caches.delete(name));
    });
  }
  
  // Ricarica la pagina senza cache
  window.location.reload(true);
};

/**
 * Avvia il monitoraggio periodico per nuove versioni
 */
export const startVersionMonitoring = (onNewVersion) => {
  const intervalId = setInterval(async () => {
    const result = await checkForNewVersion();
    if (result.hasNewVersion && onNewVersion) {
      onNewVersion(result);
    }
  }, VERSION_CHECK_INTERVAL);
  
  return () => clearInterval(intervalId);
};

const versionChecker = {
  CURRENT_VERSION,
  getDeployedVersion,
  checkForNewVersion,
  forceReload,
  startVersionMonitoring
};

export default versionChecker;
